var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotipoBgBrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 752,
    viewBox: "0 0 318 752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 357H172C127.04 288.636 35.6549 149.249 29.7934 138.612C23.932 127.975 28.4613 114.9 31.4586 109.693L93.0703 0H0V357Z",
    fill: "#42EEDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 485.516C39.0583 544.817 78.6306 604.94 83.6639 612.728C91.3971 624.694 89.5527 634.555 87.6638 637.99L23.6651 752H261.994C275.105 728.4 302.06 679.672 304.993 673.556C305.588 672.315 306.323 670.899 307.14 669.328C311.352 661.219 317.713 648.975 317.993 635.331C318.259 622.301 311.215 606.856 307.659 600.762L188.662 399H0V485.516Z",
    fill: "#3700FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipoBgBrk);
export default __webpack_public_path__ + "static/media/Logotipo_bg_BRK.0e241e868bafdee2fafea0851bd3b8cc.svg";
export { ForwardRef as ReactComponent };